import { gql } from "@apollo/client";

export const CHECK_BY_USERNAME = gql`
  query checkByUsername($username: String) {
    users(where: { username: { _ilike: $username } }) {
      id
      name
      phone
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query getUserById($id: String!) {
    users_by_pk(id: $id) {
      name
      phone
      created_at
      email
      username
      id
      stock_balance
      cash_balance
    }
  }
`;

export const GET_USERS_BY_USERNAME_NAME = gql`
  query checkByUsername($search: String) {
    users(
      where: {
        _or: [{ username: { _ilike: $search } }, { name: { _ilike: $search } }]
      }
      order_by: { name: asc }
    ) {
      id
      name
      username
    }
  }
`;

export const GET_CASH_TRANSACTIONS = gql`
  query transactionsById($id: String) {
    cash_transactions(
      where: { user_id: { _eq: $id } }
      order_by: { id: desc }
    ) {
      id
      transaction_amount
      closing_balance
      opening_balance
      message
      original_create_date
      created_at
    }
  }
`;

export const GET_CASH_PENDING = gql`
  query pendingWalletByUserId($id: String) {
    cash_balance(where: { user_id: { _eq: $id } }, order_by: { id: desc }) {
      id
      amount
      status
      description
      type
      created_at
    }
  }
`;
